import brand from '@helpers/brand';
import { Device, from } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.div `
  display: flex;
  align-items: center;
  transform: translateX(14px);
  margin-right: 15px;

  @media ${from(Device.TabletLarge)} {
    display: none;
  }
`;
const Button = styled.button `
  display: inline-flex;
  background: none;
  border: 0;
  color: currentColor;
  height: 48px;
  padding: 0;
  place-content: center;
  place-items: center;
  width: 48px;
  margin-right: 8px;

  svg {
    display: block;
    height: 24px;
    width: 24px;
  }

  &:focus {
    outline: auto;
  }
`;
const HamburgerButton = styled(Button) `
  margin-right: 0;
  background: ${brand.blue.blue5};
  border-radius: 8px;
  transition: all 0.5s ease;

  &[data-active='true'] {
    background: ${brand.yellow.base};
  }
`;
const MobileHeaderStyles = {
    Container,
    Button,
    HamburgerButton,
};
export default MobileHeaderStyles;
